// extracted by mini-css-extract-plugin
export default {"subdued":"ViewStyle_subdued__5XA-r","flexcontainer":"ViewStyle_flexcontainer__D6-CX"};